<template>
  <div class="px-3">
    <Popper
      v-if="availableLocales.length > 1"
      :content="tooltip"
      hover
      arrow
      placement="bottom"
      theme="light"
    >
      <button
        type="button"
        class="btn btn-sm btn-outline-light text-uppercase border-0 fw-bold"
        aria-label="Changer la langue"
        @click="switchLocale()"
      >
        {{ lang }}
      </button>
    </Popper>
  </div>
</template>

<script setup lang="ts">
import { getActiveLanguage, loadLanguageAsync } from 'laravel-vue-i18n'
import { PropType } from 'vue'
import { ref, computed } from 'vue'
import { useSubmissionFormStore } from '~conciergeUiCommons/store/submissionFormStore'
const props = defineProps({
  availableLocales: {
    type: Array as PropType<string[]>,
    required: false,
    default: () => ['fr', 'en']
  }
})
const initialLang = props.availableLocales.find(locale => locale !== getActiveLanguage()) ?? 'fr'
const lang = ref(initialLang)

const switchLocale = () => {
  const newLocale = props.availableLocales.find(locale => locale !== getActiveLanguage()) ?? 'fr'
  loadLanguageAsync(newLocale).then(() => {
    lang.value = props.availableLocales.find(locale => locale !== getActiveLanguage()) ?? 'fr'
    useSubmissionFormStore().setLocale(getActiveLanguage())
  })
}

const tooltip = computed(() => {
  return lang.value !== 'en' ? 'Passer au français' : 'Switch to english'
})
</script>
